import { apiRequest, HttpMethodsList } from "@utils/api";
const pdfService = {
    loadPdfJobs: (params) => apiRequest("/Jobs", params),
    loadSinglePdfJob: (jobId) => apiRequest(`/Jobs/${jobId}`, {}, false),
    loadInputFilesForJob: (jobId) => apiRequest(`/Jobs/${jobId}/inputfiles`, {}, false),
    loadOutputFilesForJob: (jobId) => apiRequest(`/Jobs/${jobId}/outputfiles`, {}, false),
    uploadFiles: (params) => apiRequest(`/Pdf/${params.jobType}`, {}, false, HttpMethodsList.POST, { "Content-Type": "application/json" }, JSON.stringify(params.data))
};
export default pdfService;
